// @flow

import { type UserInputValidationError, VALID } from '@tectonics/prs/validation';

export function validateChileanState(stateValue: string): ?UserInputValidationError {
  return stateValue ? VALID : { id: 'empty' };
}
